import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";

import utils from "@helpers/utils";
import i18nInit from "@languages/i18n";
import { apiCustomer } from "@store/services/rest";
import AppProvider from "@hooks/index";

import TelluriaApolloProvider from "@graphql/client";
import { TelluriaProvider } from "@npm-telluria-tecnologia/telluria-ui";

import { ThemeProvider } from "styled-components";
import useTheme from "@styles/useTheme";
import GlobalStyle from "@styles/global";
import { CustomerTheme } from "./styles/themes";

import { Loading } from "./atoms";

import Routes from "./routes/Routes";

const App: React.FC = () => {
  i18nInit();
  const { theme, setTheme } = useTheme();
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    async function getTheme() {
      let theme = "{}";

      try {
        const response = await apiCustomer.get("/params/customTheme");

        theme = response.data.result.key;

      } finally {
        localStorage.setItem("@Topcon:themeColors", theme);
      }

      return theme;
    }

    async function loadCustomTheme() {
      let themeColorsJson = localStorage.getItem("@Topcon:themeColors");

      if (!themeColorsJson) themeColorsJson = await getTheme();

      const themeColors = JSON.parse(themeColorsJson);
      const colors = utils.replaceWithDefaultValues(themeColors, theme.colors);
      const newTheme = { title: theme.title, colors } as CustomerTheme;

      setTheme(newTheme);
      setLoading(false);
    }

    try {
      loadCustomTheme();
    } catch {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <Loading loading />;
  }

  return (
    <TelluriaProvider components={{ toast: true }}>
      <ThemeProvider theme={theme}>
        <AppProvider>
          <TelluriaApolloProvider>
            <BrowserRouter basename="/customer">
              <GlobalStyle />
              <Routes />
            </BrowserRouter>
          </TelluriaApolloProvider>
        </AppProvider>
      </ThemeProvider>
    </TelluriaProvider>
  );
};

export default App;
